import { useEffect, useMemo } from "react"
import { useUser } from "@/apis/bff.ts"
import { useCurrentLanguage } from "@/hooks/useCurrentLanguage"
import { convertLanguageToISOCode } from "@/lib/language-to-iso-code"
import { useCallLineQuery } from "@/modules/telephony/services/useCallLinesService.ts"
import useCallContextStore from "@/stores/useCallContextStore"

const useCallLineInfo = () => {
  const callLineCode = useCallContextStore((state) => state.callLineCode)
  const toggleKidsLine = useCallContextStore((state) => state.toggleKidsLine)
  const isKidsLine = useCallContextStore((state) => state.isKidsLine)
  const language = useCurrentLanguage()
  const { countries } = useUser()

  const { fetch: fetchKidsLine, data: kidsLineData } = useCallLineQuery(callLineCode)
  const lineContent = kidsLineData?.ch_telephoneLines[0]?.telephoneLineTranslations

  const lineType = kidsLineData?.ch_telephoneLines[0]?.lineType

  const filteredTelephoneTranslation = useMemo(() => {
    return lineContent?.filter((item) => language.toUpperCase() === convertLanguageToISOCode(item.language)) || []
  }, [lineContent, language])
  useEffect(() => {
    if (callLineCode && !kidsLineData && countries.includes("CH")) {
      fetchKidsLine()
    }
  }, [fetchKidsLine, callLineCode, kidsLineData, countries])

  useEffect(() => {
    if (kidsLineData && lineType === "KIDS_LINE" && !isKidsLine) {
      toggleKidsLine(true)
    }

    if (kidsLineData && lineType !== "KIDS_LINE" && isKidsLine) {
      toggleKidsLine(false)
    }
  }, [kidsLineData, isKidsLine, lineType, toggleKidsLine])

  return filteredTelephoneTranslation[0]?.content
}

export { useCallLineInfo }
